import { css } from '@emotion/react';

const container = css`
  width: 100%;
  height: 100%;
`;

const card = css`
  && {
    height: 100%;
    background-color: var(--dcd-kering-primary-color-10);
    margin: 0;
  }
`;

const cardContent = css`
  &&& {
    display: flex;
    padding: 0;
  }
`;

const contentContainer = css`
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: var(--dcd-white-color);
  padding: 20px;
  max-width: 1200px;
`;

const title = css`
  padding: 15px 0px 25px;
  margin: 0;
`;

export default {
  container,
  contentContainer,
  title,
  cardContent,
  card,
};
